import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=bf880588&scoped=true&"
import script from "./Structure.vue?vue&type=script&setup=true&lang=js&"
export * from "./Structure.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Structure.vue?vue&type=style&index=0&id=bf880588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf880588",
  null
  
)

export default component.exports